// extracted by mini-css-extract-plugin
module.exports = {"page":"xqBc4JP_","filter":"c33VCsD_","pins":"Wh2SoxxJ","similar":"__2xMR15oC","activity":"__5q6Wal0s","close":"SSTAFBqf","container":"KLUFsWxM","img":"JaxZhGm9","time":"TC_LbHEM"};